import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

@Injectable({
    providedIn: 'root',
})
export class MomentsRunService {
    constructor (
        private readonly monEventService: MonEventService,
        private readonly dateTimeService: DateTimeService,
    ) { }

    initializeApp (): void {
        this.monEventService.addListener('afterLoadUser', (user: any) => {
            this.dateTimeService.setLocale(user.locale);
        });
    }
}
